/**
 * Shared axios instance to avoid circular dependencies between api.ts and custom.ts
 */
import Axios from 'axios';

export const axios = Axios.create();
